import { Cart, RentalCartItem } from '../clients/customer-api/cart/cart';
import { Order, OrderType } from '../clients/quipli-service/order/order';
import { sum } from 'lodash';

export type EcommerceItem = {
  index?: number;
  item_id: number;
  item_name: string;
  quantity: number;
  rental_start_date?: string;
  rental_end_date?: string;
};

export type GTMEventType = 'begin_checkout' | 'purchase' | 'add_to_cart';

export type GTMEvent = {
  event: GTMEventType;
  ecommerce: {
    transaction_id?: string;
    tax?: number;
    shipping?: number;
    value?: number;
    currency?: string;
    items: EcommerceItem[];
  };
};

export function cartToEcommerceItems(cart: Cart): EcommerceItem[] {
  return cart.items.map((ci, i) => {
    if (ci instanceof RentalCartItem) {
      return {
        index: i,
        item_id: ci.product.id,
        item_name: ci.product.name,
        quantity: ci.quantity,
        rental_start_date: ci.startDate.toISO(),
        rental_end_date: ci.endDate.toISO(),
      };
    } else {
      return {
        index: i,
        item_id: ci.product.id,
        item_name: ci.product.name,
        quantity: ci.quantity,
      };
    }
  });
}

export function orderToPurchaseEvent(order: Order, currency: string): GTMEvent {
  return {
    event: 'purchase',
    ecommerce: {
      transaction_id: order.orderNumber,
      tax: sum(order.invoices.map((inv) => inv.tax)),
      shipping: sum(
        order.invoices.flatMap((inv) => inv.lineItems).filter((li) => li.type === 'Delivery' || li.type === 'Pickup'),
      ),
      value: sum(order.invoices.map((inv) => inv.total)),
      currency,
      items: order.products.map((op, i) => {
        if (op.type === OrderType.Rental) {
          return {
            index: i,
            item_id: op.product.id,
            item_name: op.product.name,
            quantity: op.quantity,
            rental_start_date: op.rentalStartDate.toISO(),
            rental_end_date: op.rentalEndDate?.toISO(),
          };
        } else {
          return {
            index: i,
            item_id: op.product.id,
            item_name: op.product.name,
            quantity: op.quantity,
          };
        }
      }),
    },
  };
}
